"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var QqBox = function QqBox(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/social/qq_box-qq-box" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "fill-1-qq-box" + unique,
    xlinkHref: "#path-1-qq-box" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-qq-box" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4,3 L20,3 C20.5522847,3 21,3.44771525 21,4 L21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 Z M18.3926326,14.2050165 C18.3839529,13.2744712 18.0375695,12.7695932 17.6402023,12.1112532 C17.4611391,11.8362763 17.2544323,11.6521074 17.075515,11.3772034 C17.0476526,11.2281907 17.1058573,11.1165224 17.0642825,10.7248444 C17.0243853,10.1376192 16.8184079,9.91005205 16.7750097,9.83813501 C16.7936089,9.68197438 16.7339455,8.39490735 16.2867616,7.63350574 C14.9227448,5.09430906 12.3391287,5.00167758 12.0229417,5 L12.0198783,5 C11.7036914,5.00167758 9.12007533,5.094382 7.75613146,7.63350574 C7.30887457,8.39483441 7.24921115,9.68197438 7.26781038,9.83813501 C7.22441217,9.91005205 7.01843476,10.1376192 6.97861052,10.7248444 C6.93703576,11.1165224 6.99524042,11.2281907 6.96737804,11.3772034 C6.78838776,11.6521804 6.58160803,11.8363492 6.40261775,12.1112532 C6.00517764,12.7695932 5.65879424,13.2744712 5.65018754,14.2050165 C5.64376898,14.8987315 5.8012425,15.8449584 6.26892208,15.8579414 C6.41618425,15.8457607 6.54192967,15.743939 6.79765091,15.445549 C6.87401717,15.3557621 7.14323198,14.9787446 7.19764386,14.8741513 C7.25015934,15.0184959 7.37444599,16.0251157 8.24343141,16.5494682 C7.35074109,16.9870973 6.91398729,17.2638976 6.89867028,17.8318672 C6.91734245,18.1604537 7.29399519,18.5972804 7.98668903,18.8008509 C8.85917548,19.0548945 9.87411018,19.0605837 10.7188801,18.8481877 C11.2183607,18.7226611 11.3686863,18.5969157 12.02141,18.2229617 C12.6742067,18.5969157 12.8244594,18.7227341 13.32394,18.8481877 C14.1687099,19.0605108 15.1835717,19.0548945 16.0561311,18.8008509 C16.748752,18.5972804 17.1254047,18.1604537 17.1440769,17.8318672 C17.1288328,17.2638976 16.692079,16.9870973 15.7993887,16.5494682 C16.6683012,16.0251886 16.7925878,15.0185689 16.8451033,14.8741513 C16.8995881,14.9787446 17.1688029,15.3557621 17.2450962,15.445549 C17.5008904,15.744012 17.6265629,15.8457607 17.7738251,15.8579414 C18.2415047,15.8450313 18.3990511,14.8987315 18.3926326,14.2050165 Z",
    fill: "inherit",
    id: "path-1-qq-box" + unique
  }))));
};

QqBox.propTypes = propTypes;
var _default = QqBox;
exports["default"] = _default;